<script setup lang="ts">
import { Typography } from '@gro-up/ui'

export type OpeningHoursProps = {
  type: 'openingHours'
  title: string
  days: {
    day: string
    hours: string[]
  }[]
  hideTitle?: boolean
}

const { title, days, hideTitle } = defineProps<OpeningHoursProps>()
</script>

<template>
  <div class="flex flex-col gap-4">
    <header v-if="!hideTitle">
      <Typography as="header" variant="header-5">{{ title }}</Typography>
    </header>

    <div class="flex flex-col gap-2.5">
      <div v-for="(day, index) in days" :key="`contact-opening-day-${index}`" class="flex flex-wrap justify-between">
        <Typography as="div" class="font-bold" variant="caption">{{ day.day }}</Typography>
        <Typography as="div" variant="caption">{{ day.hours.join(' / ') }}</Typography>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
